import * as React from "react";
import { memo } from "react";
const SvgRoundBg = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 289, height: 56, viewBox: "0 0 289 56", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0.0803223 0.93396H288.824V55.8782H55.0245C24.6796 55.8782 0.0803223 31.2788 0.0803223 0.93396Z", fill: "#ED254E" }));
const Memo = memo(SvgRoundBg);
export default Memo;
